// extracted by mini-css-extract-plugin
export default {"list":"base-filter-thumbnails-module__list--kD3Ke"};